export const faq = {
  badge: "FAQ",
  title: "Częste pytania",
  subtitle: "Wszystko, co musisz wiedzieć o DONKEY TRAVEL",
  items: {
    q1: {
      question: "Jak działa system Wymianaów?",
      answer:
        "To bezpośrednia wymiana między dwoma właścicielami. Ustalacie daty (jednoczesne lub przesunięte) i warunki. Bez punktów, bez skomplikowanych obliczeń, po prostu po ludzku.",
    },
    q2: {
      question: "Czy muszę wymieniać się w tym samym czasie?",
      answer:
        "Nie! To cała zaleta naszego elastycznego systemu. Możesz przyjąć Jeana w kwietniu, a pojechać do niego w październiku. To pozwala też spotkać się przy przekazaniu kluczy!",
    },
    q3: {
      question: "Jak weryfikowani są członkowie?",
      answer:
        "Wszyscy członkowie muszą być zweryfikowanymi gospodarzami Airbnb. Weryfikujemy również tożsamość, mieszkanie i opinie Airbnb każdego członka, aby zagwarantować bezpieczeństwo społeczności.",
    },
    q4: {
      question: "Co się dzieje w przypadku problemu?",
      answer:
        "Nasz zespół wsparcia jest dostępny 7 dni w tygodniu, aby Ci pomóc. Ponadto nasz system opinii i ocen pozwala utrzymać zaufaną społeczność i szybko rozwiązywać wszelkie problemy.",
    },
    q5: {
      question: "Czy są ukryte opłaty?",
      answer:
        "Nie, żadnych ukrytych opłat. Płacisz tylko roczną subskrypcję zależnie od wybranej strefy geograficznej. Wymiany są następnie całkowicie darmowe, bez prowizji ani dodatkowych opłat.",
    },
    q6: {
      question: "Czy mogę wybrać, kto u mnie zamieszka?",
      answer:
        "Absolutnie! Masz pełną kontrolę. Możesz przeglądać profile, czytać opinie i akceptować lub odrzucać każdą prośbę o wymianę zgodnie z własnymi preferencjami.",
    },
    q7: {
      question: "Czy mój dom jest ubezpieczony podczas wymian?",
      answer:
        "Tak, wszystkie wymiany są objęte naszym ubezpieczeniem partnerskim. Zalecamy również sprawdzenie ubezpieczenia domowego dla optymalnej ochrony.",
    },
    q8: {
      question: "Z jakim wyprzedzeniem muszę rezerwować?",
      answer:
        "To zależy od każdego właściciela. Niektórzy akceptują rezerwacje last minute, inni wolą planować z kilkumiesięcznym wyprzedzeniem. Zalecamy rezerwację co najmniej 2-3 tygodnie wcześniej.",
    },
  },
  cta: {
    title: "Masz inne pytania?",
    subtitle:
      "Nasz zespół jest tutaj, aby pomóc Ci rozpocząć przygodę z DONKEY TRAVEL",
    button: "Skontaktuj się z nami",
  },
};
